<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="title"
      :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <p>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    saveIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import {deanDialogBus} from '@/main';
  import {getErrorFromResponse} from '@/mixins/errorMessage';

  @Component({
    components: {
      warningIcon,
      saveIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
    },
  })

  export default class CancelProvisioningConfirmationDialog extends Vue {
    // DATA
    @Prop() public payloadData!: any;

    // COMPUTED
    public get title(): string {
      return 'Annulering bevestigen';
    }

    public get text(): string {
      return String(this.$t('messages.confirmCancelProvisioning'));
    }

    // METHODS
    public close(): void {
      deanDialogBus.$emit('close');
    }

    public save(): void {
      this.$emit('setLoad', true);

      axios.post('/-/trade/api/mobile.order.line.stnProvisioning.cancel', {
        orderLineId: this.payloadData.orderLineId,
      })
      .then(
        (response: any) => {
          deanDialogBus.$emit('saved');
          this.$toast({
            icon: saveIcon,
            text: String(this.$t('messages.cancelKpnMobileProvisioning')),
            theme: 'success',
          });
          this.close();
        },
        (error: any) => {
          const errorMessage: string|null = getErrorFromResponse(
              error.response.data,
              'Request failed.'
          );

          this.$toast({
            icon: warningIcon,
            text: errorMessage ?? '',
            theme: 'danger',
          });
        },
      )
      .finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>
